import { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

import "./toast.scss";
import { gatherClasses } from "../../lib/utils";

const BODY = document.getElementsByTagName("BODY")[0];

class ToastContainer extends Component {
  constructor(props) {
    super(props);
    const { dataTestId } = props;
    this.el = document.createElement("div");
    this.el.className = gatherClasses(
      props,
      "oui-toast-container",
      "oui-col-xs-12",
      "oui-col-sm-6",
      "oui-offset-sm-3",
      "oui-col-lg-4",
      "oui-offset-lg-4"
    );
    this.el.setAttribute("data-testid", dataTestId);
  }

  componentDidMount() {
    BODY.appendChild(this.el);
  }

  componentWillUnmount() {
    BODY.removeChild(this.el);
  }

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

ToastContainer.propTypes = {
  dataTestId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.func
  ])
};

ToastContainer.displayName = "OrionToastContainer";

export default ToastContainer;
